import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { DeliveryPromise } from "@omni/types/api/cart/bff/shared/deliveryPromise.model";
import { ProductConfiguration } from "@omni/types/utils/productConfiguration";
import { Label } from "@omni/ui/components/Product/Label/label";
import { cn } from "@omni/utils/styles";
import { JSX } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { EnergyLabel } from "@/components/Product/energyLabel/energyLabel";
import { ProductConfigurationDetailComponent } from "@/components/Product/ProductConfigurationDetail/productConfigurationDetail.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { CartItemInfoDeliveryMethod } from "./deliveryMethod/cartItemInfoDeliveryMethod.component";
import { CartItemInfoTitle } from "./title/cartItemInfoTitle.component";

type CartItemInfoProps = {
    deliveryPromise?: DeliveryPromise | null;
    withRemove: boolean;
    productConfiguration?: ProductConfiguration;
    cartItem: CartItem;
    ccTooltipInfo: string;
    dsvTooltipInfo: string;
    warrantyDepositTooltipInfo: string;
    promoLabels: Array<JSX.Element>;
};

const CartItemInfo = ({
    cartItem,
    deliveryPromise,
    ccTooltipInfo,
    dsvTooltipInfo,
    warrantyDepositTooltipInfo,
    withRemove,
    promoLabels,
    productConfiguration
}: CartItemInfoProps) => {
    const { t } = useGranite();

    return (
        <Col
            xs={9}
            md={6}
        >
            <div className={cn("tw:pb-4 tw:md:pb-0")}>
                <CartItemInfoTitle
                    isConfigurableProduct={!!cartItem.articleConfiguration}
                    isWarrantyDeposit={cartItem.warrantyDeposit}
                    warrantyDepositTooltipInfo={warrantyDepositTooltipInfo}
                    cartItem={cartItem}
                    productConfiguration={productConfiguration}
                />
                <EnergyLabel energyLabel={cartItem.product?.energyLabel}>
                    <EnergyLabel.LabelNested />
                </EnergyLabel>
                {cartItem.product &&
                    cartItem.product.discountPercentage > 0 && (
                        <div className={cn("tw:md:hidden")}>
                            <Label
                                type={"label"}
                                position={"left"}
                                className={cn("tw:text-success")}
                            >
                                <Label.Entry>
                                    {t("promotionLabel.promo")}
                                </Label.Entry>
                                <Label.Entry variant={"secondary"}>
                                    {`${Math.floor(
                                        cartItem.product.discountPercentage
                                    )}%`}
                                </Label.Entry>
                            </Label>
                        </div>
                    )}
                <CartItemInfoDeliveryMethod
                    ccTooltipInfo={ccTooltipInfo}
                    deliveryPromise={deliveryPromise}
                    dsvTooltipInfo={dsvTooltipInfo}
                    isBoxArticle={cartItem.boxArticle}
                    isWarrantyDeposit={cartItem.warrantyDeposit}
                    sku={cartItem.sku}
                    boxLogisticInformation={
                        cartItem.product?.boxLogisticInformation
                    }
                    deliveryType={cartItem?.deliveryType}
                    withRemove={withRemove}
                />
                <ProductConfigurationDetailComponent
                    configuration={cartItem.articleConfiguration}
                />
                {promoLabels}
            </div>
        </Col>
    );
};

export default CartItemInfo;
